import { sdkFetch } from "@payping/api";

export interface BusinessIbanResult {
  success: boolean;
  message: string;
  iban: string;
}

export interface UpdateBusinessIbanRequestDto {
  iban: string;
}

export class BusinessIbanApi {
  static async getBusinessIban(): Promise<BusinessIbanResult> {
    const response = await sdkFetch("/v1/withdraw/business/iban", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async updateBusinessIban(request: UpdateBusinessIbanRequestDto): Promise<BusinessIbanResult> {
    const response = await sdkFetch("/v1/withdraw/business/iban", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ Iban: request.iban }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async deleteBusinessIban(iban: string): Promise<BusinessIbanResult> {
    const response = await sdkFetch(`/v1/withdraw/business/iban/${iban}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}
